import {
  MENTOR_TEMPLATE_ID,
  ORG_ADMIN_TEMPLATE_ID,
  PROGRAM_ADMIN_TEMPLATE_ID,
  RECRUITER_TEMPLATE_ID,
  STAFF_TEMPLATE_ID,
} from 'bundles/enterprise-admin-management/constants';

import _t from 'i18n!nls/enterprise-admin-management';

export const mapTemplateIdToTemplateName = (templateId: string, enableLearnerGroups?: boolean) => {
  return (
    {
      [STAFF_TEMPLATE_ID]: _t('Staff Admin'),
      [MENTOR_TEMPLATE_ID]: _t('Mentor'),
      [ORG_ADMIN_TEMPLATE_ID]: _t('Organization Admin'),
      [PROGRAM_ADMIN_TEMPLATE_ID]: enableLearnerGroups ? _t('Group Admin') : _t('Program Admin'),
      [RECRUITER_TEMPLATE_ID]: _t('Recruiter'),
    }[templateId] || _t('Unknown')
  );
};

export const mapTemplateIdToUntranslatedTemplateName = (templateId: string) => {
  return (
    {
      [STAFF_TEMPLATE_ID]: 'Staff Admin',
      [MENTOR_TEMPLATE_ID]: 'Mentor',
      [ORG_ADMIN_TEMPLATE_ID]: 'Organization Admin',
      [PROGRAM_ADMIN_TEMPLATE_ID]: 'Program Admin',
      [RECRUITER_TEMPLATE_ID]: 'Recruiter',
    }[templateId] || 'Unknown'
  );
};
